<template>
  <div class="home">
    <div id="main" class="container">
			<el-row>
				<el-col  :md="12" style="text-align: center;">
					<div style="width:360px;height:760px;margin:auto;position: relative;">
						<img ref="phonebox" v-on:click="play" class="snap-main" src="../assets/phone_box.png" alt="首页视频" style="position: absolute; z-index: 999;">
						<video ref="video" loop="loop" autoplay="autoplay"
							width="360" height="760" muted style="position: relative;top: 15px;">
							<source src="../assets/tangyuan.mp4" type="video/mp4">
							your browser does not support the video tag.
						</video>
					</div>
				</el-col>
				<el-col  :md="12">
					<div class="detail">
						<h1>汤圆记账</h1>
						<h6>家庭财务小管家</h6>

						<div class="features" style="margin-top: 60px">
							<div class="title">专业</div>
							<div class="description">多账本，全资产，丰富的统计报表，还有更具特色的二级分类</div>
						</div>
						<div class="features">
							<div class="title">纯粹</div>
							<div class="description">无理财，无广告，无后台，汤圆记账是一个纯粹的记账软件</div>
						</div>
						<div class="features">
							<div class="title">速度</div>
							<div class="description">秒级启动，3秒速记，随时记录你的生活</div>
						</div>
						<div class="features" style="margin-bottom: 60px">
							<div class="title">安全</div>
							<div class="description">数据加密同步到云端，安全有保障</div>
						</div>
						<a href="https://apps.apple.com/cn/app/%E6%B1%A4%E5%9C%86%E8%AE%B0%E8%B4%A6/id1581945829" style="text-decoration: none;">
							<button type="button" class="btn-download ios">iOS版下载</button>
						</a>
						<a href="https://tangyuanjizhang.com/upload/tangyuanjizhang.apk" style="text-decoration: none;">
							<button type="button" class="btn-download">Android版下载</button>
						</a>
						<img class="qrcode-download" src="../assets/qrcode_download.png" alt="Android版下载">
						<div style="font-size: 12px;">扫码下载Android版</div>
					</div>
				</el-col>
        </el-row>
        <div style="clear:both;"></div>
			</div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Footer,
  },
  mounted() {
    this.$refs["video"].play();
  },
  methods: {
    play() {
      this.$refs["video"].play();
    }
  },
}
</script>

<style lang="scss" scope>
@import '@/scss/public.scss';

.home {
  display: -webkit-box;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  -webkit-box-flex: 1;
}

video::-webkit-media-controls {
    display:none !important;
}

#main {
  -webkit-box-flex: 1;
  background: $color-white;
  padding-bottom: 70px;
  padding-top: 40px;
  width: 100%;
}

.detail {
  margin-left: 25px;
}

.snap-main {
	width: 360px;
	height: 790px;
}

h1 {
	margin-top: 40px;
	margin-bottom: 0px;
	font-size: 2.5rem;
}
h6 {
	font-size: 1rem;
	margin-top: 0;
	margin-bottom: .5rem;
	font-weight: 500;
}

.btn-download {
	font-size: 16px;
	display: block;
	height: 50px;
	line-height: 50px;
	width: 200px;
	margin-top: 20px;
	color: #FFF;
	background: #FE5A5C;
	outline: none;
	border: none;
	border-radius: 3px;
  transition: background .3s;

  &:hover{
    background: #d23e40;
  }

  &:focus {
    outline:none;
  }
}

.btn-download.ios {
	background: #5d76d8;

	&:hover{
		background: #3b53af;
	}

	&:focus {
		outline:none;
	}
}

.qrcode-download {
	margin-top: 10px;
	width: 120px;
}

.features {
  margin: 20px 0px 10px 0px;

  .title {
    font-size: 16px;
    color: #000000;
  }

.description {
    font-size: 12px;
    color: #999999;
  }
}
</style>
